export const TERMINOLOGY = {
  document: 'information',
  documents: 'informationer',
  organisation: 'virksomhed',
  organisations: 'virksomheder',
  "startOverviews.myPage": 'Min Side',
  "startOverviews.editor": 'Redigering',
  "user.username": 'regionalt brugernavn',
};
